import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
// import { ExercisableVestingSharePlanUnionType } from '../../types/pool-plans.types';
import { useAppQuery } from '../use-app-query.hook';

export const useExercisableVestingSharePlan = ({ companyId }: { companyId: string }) => {
  const queryClient = useQueryClient();

  const { data: exercisableVestingSharePlans, isLoading } = useAppQuery<unknown[]>({
    queryKey: [QueryKey.GET_EXERCISABLE_VESTING_SHARE_PLAN, companyId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'exercisable-vesting'],
      }),
    enabled: !!companyId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EXERCISABLE_VESTING_SHARE_PLAN] });
  }, [queryClient]);

  return {
    invalidateQuery,
    exercisableVestingSharePlans: exercisableVestingSharePlans || [],
    isLoading,
  };
};
